// French Republican calendar, for the years it was in civil use. Year I starts
// on 22 September 1792; years III, VII and XI are sextile (366 days), which puts
// each 1 vendémiaire on the Gregorian date the Convention fixed.
const MONTHS = [
    'vendémiaire', 'brumaire', 'frimaire', 'nivôse', 'pluviôse', 'ventôse',
    'germinal', 'floréal', 'prairial', 'messidor', 'thermidor', 'fructidor',
];
const COMPLEMENTARY_DAYS = [
    'jour de la Vertu', 'jour du Génie', 'jour du Travail',
    "jour de l'Opinion", 'jour des Récompenses', 'jour de la Révolution',
];
const ROMAN = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII', 'XIII', 'XIV'];
const SEXTILE = new Set([3, 7, 11]);
const DAY_MS = 86_400_000;
const YEAR_I_START = Date.UTC(1792, 8, 22);

/** "9 thermidor an II" for a Gregorian date from 1793 to 1805, else undefined. */
export function republicanDateString(year: number, month: number, day: number): string | undefined {
    if (year < 1793 || year > 1805 || !month || !day) {
        return undefined;
    }
    let days = Math.round((Date.UTC(year, month - 1, day) - YEAR_I_START) / DAY_MS);
    let an = 1;
    while (days >= (SEXTILE.has(an) ? 366 : 365)) {
        days -= SEXTILE.has(an) ? 366 : 365;
        an++;
    }
    const monthIndex = Math.floor(days / 30);
    const dayOfMonth = (days % 30) + 1;
    const label = monthIndex < 12
        ? `${dayOfMonth === 1 ? '1er' : dayOfMonth} ${MONTHS[monthIndex]}`
        : COMPLEMENTARY_DAYS[dayOfMonth - 1];
    return `${label} an ${ROMAN[an - 1]}`;
}
